!<template>
<div>
    <div class="modal fade bobo" id="Modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Crear</h4>
                </div>
                <form @submit.prevent="accion">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <div class="form-group">
                                        <label>Canal</label>
                                        <div class="input-group">
                                            <multiselect placeholder="Selecciona canal" label="nombre" :taggable="true" track-by="id" v-model="canal" :options="canales"></multiselect>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6" v-if="canal != ''">
                                <div class="form-group">
                                    <div class="form-group">
                                        <label>Tipo</label>
                                        <div class="input-group">
                                            <multiselect placeholder="Selecciona tipo" label="nombre" :taggable="true" track-by="id" v-model="tipo" :options="tipos"></multiselect>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="row" v-if="canal != ''">
                            <div class="col-md-12">
                                <h2>Usuario</h2>
                            </div>
                        </div>
                        <div class="row" v-if="canal != ''">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Nombre</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-addon"><i class="fal fa-tag"></i> </span>
                                        </div>
                                        <input class="form-control " placeholder="Nombre" type="text" v-model="usuario.nombre">

                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Apellido</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-addon"><i class="fal fa-tag"></i> </span>
                                        </div>
                                        <input class="form-control " placeholder="Apellido" type="text" v-model="usuario.apellido">

                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{canal.slug == "correo" ? "Email" : "Telefono"}}</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-addon"><i class="fal fa-tag"></i> </span>
                                        </div>
                                        <input class="form-control " placeholder="Email" type="text" v-if="canal.slug == 'correo'" v-model="usuario.email">
                                        <input class="form-control " placeholder="Telefono" type="text" v-if="canal.slug != 'correo'" v-model="usuario.telefono">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="canal != ''">
                            <div class="col-md-12">
                                <h2>Cita</h2>
                            </div>
                        </div>
                        <div class="row" v-if="canal != ''">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Especialidad</label>
                                    <div class="input-group">
                                        <multiselect placeholder="Selecciona Especialidad" label="nombre" :taggable="true" track-by="id" v-model="cita.especialidad" :options="servicios"></multiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Servicios</label>
                                    <div class="input-group">
                                        <multiselect placeholder="Selecciona Servicio" label="nombre" :taggable="true" track-by="id" v-model="cita.servicio" :options="servicios_especialidad"></multiselect>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="canal != ''">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Tipo Cita</label>
                                    <div class="input-group">
                                        <multiselect placeholder="Selecciona tipo cita" label="abrev" :taggable="true" track-by="id" v-model="cita.tipo_cita" :options="tipo_citas"></multiselect>

                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Establecimiento</label>
                                    <div class="input-group">
                                        <multiselect placeholder="Selecciona Establecimiento" label="nombre" :taggable="true" track-by="id" v-model="cita.establecimiento" :options="establecimientos"></multiselect>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn-primary btn" type="submit">Aceptar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
    components: { Multiselect },
    props: ['canales', 'vouchers', 'tipo_citas', 'servicios', 'establecimientos'],
    data() {
        return {
            usuario: {
                nombre: "",
                apellido: "",
                email: "",
                telefono: ""
            },
            cita: {
                tipo_cita: "",
                servicio: "",
                especialidad: "",
                establecimiento: ""
            },
            tipo_cita: "",
            canal: '',
            tipos: [],
            tipo: '',
            servicios_especialidad: []
        }
    },
    mounted() {


    },
    methods: {
        show() {
            this.usuario = {
                nombre: "",
                apellido: "",
                email: "",
                telefono: ""
            }
            this.cita = {
                tipo_cita: "",
                especialidad: "",
                servicio: "",
                establecimiento: ""
            }
            this.servicios_especialidad = [];

            this.tipo_cita = ""
            this.canal = ''
            $('#Modal').modal('show')
        },
        hide() {
            this.usuario = {
                nombre: "",
                apellido: "",
                email: "",
                telefono: ""
            }
            this.cita = {
                tipo_cita: "",
                especialidad: "",
                servicio: "",
                establecimiento: ""
            }
            this.servicios_especialidad = [];

            this.tipo_cita = ""
            this.canal = ''
            $('#Modal').modal('hide')
        },
        accion() {
            let x = this.verifica();
            if (x) {
                this.$swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Verifique formulario. ' + x,
                    showConfirmButton: true,
                    timer: 1500,
                });
                return;
            }

            let data = {
                usuario: this.usuario,
                cita: this.cita,
                canal: this.canal,
                tipo: this.tipo
            }
            axios.post('create-prueba', data).then(response => {
                this.$swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Enviado',
                    text: 'Correctamente',
                    showConfirmButton: true,
                    timer: 1500,
                });
                this.$emit('guardar', response.data);
                this.hide();
            }).catch(error => {
                this.$swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Ha ocurrido un error',
                    showConfirmButton: true,
                    timer: 1500,
                });
            })
        },
        verifica() {
            if (this.canal == "" || this.canal == null) {
                return "Canal"
            }

            if (this.tipo == "" || this.tipo == null) {
                return "Tipo de Prueba"
            }

            if (this.canal.slug == "correo") {
                if (!this.usuario.email.match(
                        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    )) {
                    return "Ingrese un correo"
                }
            }
            for (const index in this.usuario) {
                if (this.usuario[index] == "" || this.usuario[index] == null) {
                    if (this.canal.slug == "correo") {
                        if (index != "telefono")
                            return index + " usuario";
                    } else {
                        if (index != "email")
                            return index + " usuario";
                    }
                }
            }

            for (const index in this.cita) {
                if (this.cita[index] == "" || this.cita[index] == null) {
                    return index
                }
            }

            return null;
        }
    },
    watch: {
        canal() {
            // console.log(this.canal);
            if (this.canal.slug == "correo") {
                this.tipos = this.vouchers['correo']
                this.tipo = '';
            }
            if (this.canal.slug == "telefono") {
                this.tipos = this.vouchers['telefono']
                this.tipo = ''
            }
            if (this.canal.slug == "whatsapp") {
                this.tipos = this.vouchers['whatsapp']
                this.tipo = ''

            }
            if (this.canal.slug == "sms") {
                this.tipos = this.vouchers['sms']
                this.tipo = ''

            }
        },
        "cita.especialidad"() {
            // console.log(this.cita.especialidad);
            if (this.cita.especialidad) {
                this.servicios_especialidad = this.cita.especialidad.servicios;
                this.cita.servicio = ""
            }

        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect__tag {
    background: #adadad;
}

.multiselect__tag-icon:after {
    color: black
}

.multiselect__option--highlight {
    background: #707070;
}

.swal2-container {
    z-index: 999999999 !important;
}
</style>
